import React, { Fragment, useContext, useEffect, useState } from "react";
// Provider
import {
  AppContext,
  SocketCommand,
  socketManager,
} from "../../../components/AppProvider";

// Utils
import { _O } from "../../../modules/utils";

// UI
import { Doctor, IC } from "../../../resources/Assets";
import { ScrollToTop } from "../../common/ScrollToTop/ScrollToTop";
import {
  AlertPopup,
  Container,
  DateTimeLayer,
  DeviceBpBuyLayer,
  DeviceInputLayer,
  closeLayerFn,
  openAlertPopup,
  openLayerFn,
} from "../../Layout";
import { DoctorMessage } from "../SM.Layers";

// Temp Images
import _ICON_MINUS from "../../../resources/images/icon/icon_minus_circle_min.png";
import _ICON_PLUS from "../../../resources/images/icon/icon_plus_circle_min.png";

import AutoBp from "../../../components/AD/AutoBp";
import { AlertLayer, ConfirmLayer } from "../../../components/UI/Dialog";
import useTitle from "../../../modules/hooks/useTitle";
import {
  PostApi1101,
  PostApi1109,
  PostApi999,
} from "../../../modules/network/padoPost";
import { maxLengthCheck } from "../../../modules/utils/CheckLogic";
import { NativeAction } from "../../../modules/utils/HandleWs";
import { userHabit } from "../../../modules/utils/UserHabit";
import DvcInputLayer from "../../common/Layer/DvcInputLayer";
import { SUBS, SubMenu } from "./History";
import { TargetBPLayer } from "./InputList/Component/TargetBpLayer";

export default props => {
  useTitle("자가건겅관리_혈압_입력");
  const gaugeBoxInfo = [
    {
      idx: 1,
      maxBp: "",
      minBp: "",
      bpm: "",
    },
  ];

  const [display, setDisplay] = useState(false);

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleDialog = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".alert-layer"));
  };

  const handleConfirmDiolog = target => {
    // 입력된 값이 있으면 초기화 여부 확인
    if (target === "inlineCheckbox1") {
      settingHandsLeft();
    } else {
      settingHandsRight();
    }

    if (checkInputBox() === false) {
      setDialog({
        title: "",
        msg: "입력한 정보를 초기화 하시겠습니까?",
      });

      openLayerFn($(".confirm-layer"));
    }

    // 반대 체크박스 풀기
    if (target === "inlineCheckbox1") {
      $("#inlineCheckbox2").prop("checked", false);
    } else {
      $("#inlineCheckbox1").prop("checked", false);
    }
  };

  const resetInputBox = () => {
    $("#inputMaxBp").val("");
    $("#inputMinBp").val("");
    $("#inputHeartRate").val("");

    closeLayerFn($(".confirm-layer"));
  };

  const checkInputBox = () => {
    let returnValue = true;
    if (
      $("#inputMaxBp").val() != "" ||
      $("#inputMinBp").val() != "" ||
      $("#inputHeartRate").val() != ""
    ) {
      returnValue = false;
    }

    return returnValue;
  };

  // 현재 날짜 시간 기본설정
  const toDay = new Date();
  //요일 설정
  const week = new Array("일", "월", "화", "수", "목", "금", "토");

  let defaultYear = toDay.getFullYear();
  let defaultMonth = toDay.getMonth() + 1;
  let defaultDate = toDay.getDate();

  let defaultHours = toDay.getHours();
  let defaultMin = toDay.getMinutes();

  let defaultDay = week[toDay.getDay()];
  let defaultAmPm;

  if (defaultHours < 12) {
    defaultAmPm = "오전";
  } else {
    defaultAmPm = "오후";
    // if(defaultHours != 12) {
    //     defaultHours = defaultHours - 12;
    // }
  }

  if (defaultMonth < 10) {
    defaultMonth = "0" + defaultMonth;
  }

  if (defaultDate < 10) {
    defaultDate = "0" + defaultDate;
  }

  if (defaultHours < 10) {
    defaultHours = "0" + defaultHours;
  }

  if (defaultMin < 10) {
    defaultMin = "0" + defaultMin;
  }

  // 9월 28일 화 오전 08:50
  // 2022.09.28(화) 17:15
  const defaultValue =
    defaultMonth +
    "월" +
    " " +
    defaultDate +
    "일" +
    " " +
    defaultDay +
    " " +
    defaultAmPm +
    " " +
    defaultHours +
    ":" +
    defaultMin;

  const sub = SUBS[0];
  const [boxData, setBoxData] = useState(gaugeBoxInfo);
  const [boxCount, setBoxCount] = useState(1);

  // param
  const { auth, userinfo, cfg, phonecfg, deviceCfg, dispatch, appStdInfo } =
    useContext(AppContext);

  // BT연결
  // const [isConnected, setIsConnected] = useState(deviceCfg.deviceTypes[0].devices[0].isConnected);
  const [isConnected, setIsConnected] = useState(false);
  const [deviceState, setDeviceState] = useState();
  const [connection, setConnection] = useState();
  const [getData, setGetData] = useState();

  // 혈압입력
  // const [inputType, setInputType] = useState(deviceCfg.deviceTypes[0].autoInput === true ? "A" : "M"); // 입력타입 M:수동 A:자동
  const [inputType, setInputType] = useState("M"); // 입력타입 M:수동 A:자동
  const [bpcTimeCd, setBpcTimeCd] = useState("01");
  const [bpcDate, setBpcDate] = useState(
    defaultYear + "" + defaultMonth + "" + defaultDate
  );
  const [bpcTime, setBpcTime] = useState(defaultHours + "" + defaultMin);
  const [handsCheck, setHandsCheck] = useState("L"); // 손 방향 R:오른손 L:왼손
  const [maxBp, setMaxBp] = useState([]);
  const [minBp, setMinBp] = useState([]);
  const [hrtRate, setHrtRate] = useState([]);
  const [bpcMemo, setBpcMemo] = useState();

  const [trgtMaxBp, setTrgtMaxBp] = useState("");
  const [trgtMinBp, setTrgtMinBp] = useState("");

  // const [autoData, setAutoData] = useState();

  // return변수
  // const [returnValue, setReturnValue] = useState({});

  const [isBuyBpDisplay, setIsBuyBpDisplay] = useState(false);
  const [dvcTitle, setDvcTitle] = useState("");

  // 데이터 배열 변수
  // let maxBpArr = new Array();
  // let minBpArr = new Array();
  // let hrtRateArr = new Array();

  // let maxBpCnt = 0;
  // let minBpCnt = 0;
  // let hrtRateCnt = 0;

  // const addGaugeBox = () => {
  //   setBoxCount(boxCount + 1);
  //   setBoxData([
  //     ...boxData,
  //     {
  //       idx: boxData.length + 1,
  //       maxBp: "",
  //       minBp: "",
  //       bpm: "",
  //     },
  //   ]);
  // };

  // const settingInputType = () => {
  //   const socketList = SocketCommand;
  //   if (inputType === "M") {
  //     socketList.BP_AUTOINPUT_STAUS.data.autoInput = true;
  //   } else {
  //     socketList.BP_AUTOINPUT_STAUS.data.autoInput = false;
  //   }

  //   dispatch({ type: SET_SOCKETCOMMAND, data: socketList });

  //   socketManager(SocketCommand.BP_AUTOINPUT_STAUS, setInputType);
  // };

  const settingHandsRight = () => {
    setHandsCheck("R");
  };

  const settingHandsLeft = () => {
    setHandsCheck("L");
  };

  // const toggleAction = target => {
  //   $("#" + target).toggle();
  //   $("#" + target + "Plus").toggle();
  //   $("#" + target + "Minus").toggle();
  // };

  useEffect(() => {
    //혈압입력 자동입력, 수동입력 토글
    $(".toggle-inputcheck a").click(function () {
      $(this).toggleClass("off");
      // openAlertPopup("서비스 오픈 예정입니다.");
    });

    //주치의 메세지 닫기(확인버튼)
    $(".close-doctor-message").click(function () {
      // closeLayerFn($(".doctor-message-layer"));
      _O.Open("/sm/bp/list/3/1/1");
    });

    ////확인 버튼 (혈압을 저장 하겠습니까? 레이어) //열기
    //닫기
    $(".save-question-layer .tbns-area a").click(function () {
      closeLayerFn($(".save-question-layer"));
    });
  }, [appStdInfo]);

  const resetData = () => {
    setBoxCount(1);

    // 1차 측정 데이터 초기화
    $("input[name=minBp]").val("");
    $("input[name=maxBp]").val("");
    $("input[name=hrtRate]").val("");

    // 특이사항 초기화
    $(".he1").val("");
  };

  // 연결 onClick
  const bottomBtnEvnet = param => {
    if (param == "SET") {
      _O.Open("/mp/settings/accessory");
    } else if (param == "RE") {
      setDeviceState("ing");
      socketManager(SocketCommand.BP_CONNECT, callbackEvt);
    }
  };

  const goStore = () => {
    setIsBuyBpDisplay(true);
    // NativeViewOpen(
    //   phonecfg.phoneOS,
    //   "https://smartstore.naver.com/mdpharmer/products/7662699974"
    // );
  };

  const request1109 = () => {
    PostApi1109(userinfo, phonecfg, cfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.result != "") {
            setTrgtMaxBp(res.result.maxBp);
            setTrgtMinBp(res.result.minBp);
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    userHabit(phonecfg, "BP110");
    NativeAction(phonecfg, "statusColor", "#7FD2C2");
  }, [phonecfg.version]);

  useEffect(() => {
    PostApi999(phonecfg, cfg, userinfo.userToken)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.resultList === 1) {
          } else {
            openLayerFn($(".alert-layer-logout"));
            // dispatch({ type: LOG_OUT_SUCCESS });
            // socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
            //   login: "out",
            //   userToken: "",
            // });
          }
        }

        request1109();
      })
      .catch(err => {
        // openLayerFn($('.alert-layer-logout'));
        // dispatch({ type: LOG_OUT_SUCCESS });
        // socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {"login":"out", "userToken":""});
        // openLayerFn($(".alert-layer-cnntFail"));
      });
  }, []);

  // 저장 이벤트
  const onClickToSave = () => {
    let canSave = true;
    let maxBpArr = new Array();
    let minBpArr = new Array();
    let hrtRateArr = new Array();

    let maxBpCnt = 0;
    let minBpCnt = 0;
    let hrtRateCnt = 0;

    maxBpArr = [];
    minBpArr = [];
    hrtRateArr = [];

    let checkMaxMin;
    let checkStatus = "SUCCESS";

    // 빈값 체크
    if (!auth) _O.OpenMenu("/membership/login/2");
    else {
      if ($(".pick-result").val() === "") {
        openAlertPopup("날짜/시간을 선택해 주세요.");
        canSave = false;
        return;
      }

      if ($("#inputMaxBp").val() === "") {
        maxBpCnt = 0;
        canSave = false;
        openAlertPopup("수축기 값을 확인하세요.");
        return false;
      } else {
        // 30 <= 20 <= 600
        if (
          appStdInfo.bpMin <= parseInt($("#inputMaxBp").val()) &&
          parseInt($("#inputMaxBp").val()) <= appStdInfo.bpMax
        ) {
          maxBpArr.push($("#inputMaxBp").val());
          maxBpCnt = 1;
        } else {
          openAlertPopup("수축기 값을 확인하세요.");
          canSave = false;
          return false;
        }
      }

      if ($("#inputMinBp").val() === "") {
        minBpCnt = 0;
        canSave = false;
        openAlertPopup("이완기 값을 확인하세요.");
        return false;
      } else {
        if (
          appStdInfo.bpMin <= parseInt($("#inputMinBp").val()) &&
          parseInt($("#inputMinBp").val()) <= appStdInfo.bpMax
        ) {
          minBpArr.push($("#inputMinBp").val());
          minBpCnt = 1;
        } else {
          openAlertPopup("이완기 값을 확인하세요.");
          canSave = false;
          return false;
        }
      }

      if (parseInt($("#inputMaxBp").val()) < parseInt($("#inputMinBp").val())) {
        openAlertPopup("입력 값을 확인하세요");
        return false;
      }

      if ($("#inputHeartRate").val() === "") {
        hrtRateArr.push("0");
        hrtRateCnt = 1;
      } else {
        if (
          appStdInfo.hrtRateMin <= parseInt($("#inputHeartRate").val()) &&
          parseInt($("#inputHeartRate").val()) <= appStdInfo.hrtRateMax
        ) {
          hrtRateArr.push($("#inputHeartRate").val());
          hrtRateCnt = 1;
        } else {
          canSave = false;
          return false;
        }
      }

      // max min 크기 비교
      checkMaxMin = 0;
      setMaxBp(maxBpArr);
      setMinBp(minBpArr);
      setHrtRate(hrtRateArr);

      if (maxBpCnt == 0) {
        openAlertPopup("수축기 값을 확인하세요.");
        return;
      }

      if (minBpCnt == 0) {
        openAlertPopup("이완기 값을 확인하세요.");
        return;
      }

      setBpcMemo($(".he1").val());

      if (checkMaxMin > 0) {
        openAlertPopup("입력한 혈압을 확인하세요.");
      } else {
        // if(checkStatus == 'SUCCESS') {
        if (canSave) {
          openLayerFn($(".save-question-layer"));
        } else {
          openAlertPopup("입력한 혈압/심박수를 확인하세요.");
        }
      }
    }
  };

  return (
    <Fragment>
      <ScrollToTop />
      <Container
        Title={sub.label}
        goToUrl="/sm"
        onClick={bottomBtnEvnet}
        color="green">
        <div className="contents sub">
          <SubMenu code={sub.code} />

          <div className="sub-contents" style={{ padding: "0px 16px 50px" }}>
            {/* 목표혈압 */}
            <div
              className="m-section my-hospital-list"
              style={{ padding: "0px" }}>
              <div className="main-section-title" style={{ fontSize: "16px" }}>
                목표혈압
                <a
                  className="btn-myset btn1"
                  onClick={() => openLayerFn($(".bloodgoal-layer"))}></a>
                <div
                  className="subtxt_btn"
                  onClick={() => openLayerFn($(".bloodgoal-layer"))}>
                  목표혈압 설정
                </div>
              </div>
            </div>

            <div className="page-bloodpressure-card01">
              <ul style={{ padding: "0px 15px" }}>
                <li>
                  <table style={{ height: "100%" }}>
                    <tbody>
                      <tr>
                        <td
                          rowSpan="2"
                          alt="icon_compress"
                          className="goal_img">
                          <img
                            src={IC.bp.IC_MAX_BP}
                            width="28em"
                            style={{ verticalAlign: "middle" }}
                          />
                        </td>
                        <td
                          alt="title"
                          className="goal_index"
                          style={{
                            height: "1.8rem",
                            verticalAlign: "bottom",
                          }}>
                          수축기
                        </td>
                        <td rowSpan="2" alt="value" className="goal_bignum_red">
                          {trgtMaxBp !== 9999
                            ? trgtMaxBp != 0
                              ? trgtMaxBp
                              : "135"
                            : "135"}
                        </td>
                        <td rowSpan="2" style={{ width: "2px" }}>
                          |
                        </td>
                        <td rowSpan="2" alt="icon_expand" className="goal_img">
                          <img
                            src={IC.bp.IC_MIN_BP}
                            width="28em"
                            style={{ verticalAlign: "middle" }}
                          />
                        </td>
                        <td
                          alt="title"
                          className="goal_index"
                          style={{ height: "1.8rem" }}>
                          이완기
                        </td>
                        <td
                          rowSpan="2"
                          alt="value"
                          className="goal_bignum_blue">
                          {trgtMinBp !== 9999
                            ? trgtMinBp != 0
                              ? trgtMinBp
                              : "85"
                            : "85"}
                        </td>
                      </tr>
                      <tr>
                        <td className="goal_index_caption">최고혈압</td>
                        {/* <td></td> */}
                        <td className="goal_index_caption">최소혈압</td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>
            </div>
            {/* 목표혈압 */}

            <div className="section-box">
              <div className="sub-title" style={{ padding: "20px 0px" }}>
                <div>
                  {/* <img src={IC.bp.IC_BUY_ANIMATION} onClick={()=>goStore()} /> */}
                  <AutoBp click={goStore} />
                </div>
              </div>

              <div
                className="main-section-title"
                style={{ paddingBottom: "0px" }}>
                측정혈압입력
                <a
                  className="btn-myset btn1"
                  onClick={() => _O.OpenMenu("/sm/bp/guide/M")}
                />
                <div
                  className="subtxt_btn"
                  onClick={() => _O.OpenMenu("/sm/bp/guide/M")}>
                  혈압가이드
                </div>
              </div>
              <div className="full-input">
                <div className="inp-with-unit">
                  {/* <input type="text" className="textbox fat num" id="inputHeartRate" style={{height:"46px"}}  placeholder="혈압 측정기 등록" /> */}
                  <DeviceInputLayer
                    type={"BP"}
                    typeNm={"혈압"}
                    setIsDisplay={setDisplay}
                    dvcTitle={dvcTitle}
                  />
                </div>
              </div>
              <div className="full-input">
                <div className="inp-with-unit">
                  {/* <input type="text" className="textbox fat num"  placeholder="2022.08.30(화) 17:15"  /> */}
                  <div>
                    {/* <input type="text" className="textbox datetime-picker-input pick-result" style={{height:'54px', lineHeight:'54px', fontSize:'0.9rem'}} placeholder="날짜/시간을 선택해 주세요." defaultValue={defaultValue} readOnly /> */}
                    <DateTimeLayer
                      setBpcDate={setBpcDate}
                      setBpcTime={setBpcTime}
                      bpcTime={bpcTime}
                      bpcDate={bpcDate}
                    />
                  </div>
                </div>
              </div>

              {/* 입력 폼 */}
              <div className="section-box" style={{ marginTop: "20px" }}>
                <div
                  className="form-check form-check-inline"
                  style={{ display: "inline-block" }}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox1"
                    defaultValue="option1"
                    style={{ color: "black", accentColor: "black" }}
                    onClick={() => handleConfirmDiolog("inlineCheckbox1")}
                    defaultChecked
                  />
                  <label
                    className="form-check-label"
                    htmlFor="inlineCheckbox1"
                    style={{ paddingLeft: "10px" }}
                    onClick={() => handleConfirmDiolog("inlineCheckbox1")}>
                    왼팔
                  </label>
                </div>
                <div
                  className="form-check form-check-inline"
                  style={{ display: "inline-block", marginLeft: "23px" }}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox2"
                    defaultValue="option2"
                    style={{ accentColor: "black" }}
                    onClick={() => handleConfirmDiolog("inlineCheckbox2")}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="inlineCheckbox2"
                    style={{ paddingLeft: "10px" }}
                    onClick={() => handleConfirmDiolog("inlineCheckbox2")}>
                    오른팔
                  </label>
                </div>

                <div className="full-input">
                  <table>
                    <tbody>
                      <tr>
                        <td className="inp-with-unit">
                          <input
                            type="number"
                            pattern="\d*"
                            className="textbox fat num"
                            id="inputMaxBp"
                            style={{ height: "46px", lineHeight: "46px" }}
                            placeholder="최고혈압"
                            onChange={e => maxLengthCheck(e, 3)}
                            defaultValue=""
                          />
                          <i>mmHg</i>
                        </td>
                        <td width="16vw"></td>
                        <td className="inp-with-unit">
                          <input
                            type="number"
                            pattern="\d*"
                            className="textbox fat num"
                            id="inputMinBp"
                            style={{ height: "46px", lineHeight: "46px" }}
                            placeholder="최소혈압"
                            onChange={e => maxLengthCheck(e, 3)}
                            defaultValue=""
                          />
                          <i>mmHg</i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="full-input">
                  <div className="inp-with-unit">
                    <input
                      type="number"
                      pattern="\d*"
                      className="textbox fat num"
                      id="inputHeartRate"
                      style={{ height: "46px", lineHeight: "46px" }}
                      placeholder="심박수"
                      onChange={e => maxLengthCheck(e, 3)}
                    />
                    <i>bpm</i>
                  </div>
                </div>
              </div>
              {/* 입력 폼 */}

              {/* 특이사항 */}
              <div className="section-box">
                <div
                  className="main-section-title"
                  style={{ fontSize: "16px", marginTop: "32px" }}>
                  특이사항
                </div>
                <div>
                  <textarea
                    className="textarea-box gray he1"
                    style={{ resize: "none", height: "88px" }}
                    placeholder="특이사항 및 메모를 입력해주세요."></textarea>
                </div>
              </div>
              {/* 특이사항 */}
            </div>

            <SectionBoxBtn onClickToSave={() => onClickToSave()} />
          </div>
        </div>
      </Container>
      {isBuyBpDisplay && (
        <DeviceBpBuyLayer setIsBuyBpDisplay={setIsBuyBpDisplay} />
      )}
      <InputSaveLayer
        userInfo={userinfo}
        phonecfg={phonecfg}
        cfg={cfg}
        inptType={inputType}
        bpcTimeCd={bpcTimeCd}
        bpcDate={bpcDate}
        bpcTime={bpcTime}
        bpcTrgt={handsCheck}
        bpcMemo={bpcMemo}
        maxBp={maxBp}
        minBp={minBp}
        hrtRate={hrtRate}
      />
      <DoctorMessage image={Doctor.male.good} message="INPUT" />
      <AlertPopup />
      <AlertLayer title={dialog.title} msg={dialog.msg} />
      <ConfirmLayer
        title={dialog.title}
        msg={dialog.msg}
        handleCancelCB={() => closeLayerFn($(".confirm-layer"))}
        handleConfirmCB={() => resetInputBox()}
      />

      <TargetBPLayer
        trgtMaxBp={trgtMaxBp}
        trgtMinBp={trgtMinBp}
        setTrgtMaxBp={setTrgtMaxBp}
        setTrgtMinBp={setTrgtMinBp}
      />
      {display && (
        <DvcInputLayer
          type={"BP"}
          typeNm={"혈압"}
          setIsDisplay={setDisplay}
          setDvcTitle={setDvcTitle}
        />
      )}
    </Fragment>
  );
};

const MealSelectArea = props => {
  const { setBpcTimeCd, defaultValue, settingHandsRight, settingHandsLeft } =
    props;

  return (
    <div className="meal-select-date">
      {/* 날짜 선택 */}
      <PeriodArea setBpcTimeCd={setBpcTimeCd} defaultValue={defaultValue} />
      {/* 팔체크 */}
      <CheckHands
        settingHandsRight={settingHandsRight}
        settingHandsLeft={settingHandsLeft}
      />
    </div>
  );
};

const DeviceStateBox = props => {
  const { deviceState, isConnected } = props;
  // false:연결실패 true:연결성공 ing:연결중
  console.log(
    "deviceState====" + deviceState + "|| isConnected====" + isConnected
  );
  return (
    <div className="device-state-box">
      {/* 연결중일땐 이미지 대신 div(.connecing) */}
      {isConnected == false ? (
        <ConnectNohing />
      ) : deviceState == "ing" ? (
        <Connecting />
      ) : deviceState == true ? (
        <ConnectSuccess />
      ) : (
        <ConnectFail />
      )}
    </div>
  );
};

const ConnectFail = () => {
  return (
    <Fragment>
      <img src={IC.device.failure} alt="" />
      <p>
        자동연결이 실패 하였습니다.
        <br />
        측정 가능한 기기를 다시 연결해 주세요.
      </p>
    </Fragment>
  );
};

const ConnectSuccess = () => {
  return (
    <Fragment>
      <img src={IC.device.success} alt="" />
      <p>기기와 연결 되었습니다.</p>
    </Fragment>
  );
};

const Connecting = () => {
  return (
    <Fragment>
      <div className="connecing"></div>
      <p>기기 연결중입니다.</p>
    </Fragment>
  );
};

const ConnectNohing = () => {
  return (
    <Fragment>
      <img src={IC.device.nothing} alt="" />
      <p>
        기기 정보가 없습니다.
        <br />
        측정 가능한 기기를 연결해 주세요.
      </p>
    </Fragment>
  );
};

const GaugeContainer = props => {
  const { boxData, boxCount, setBoxCount, getData, addGaugeBox } = props;
  return (
    <div className="gauge-info-contain">
      {/* <!-- 1차 측정 --> */}
      <GaugeBox
        boxData={boxData}
        boxCount={boxCount}
        setBoxCount={setBoxCount}
        getData={getData}
      />

      {/* <!-- 버튼 : 추가측정 --> */}
      {boxCount < 3 && <BtnAddGaugeBox addGaugeBox={addGaugeBox} />}
    </div>
  );
};

const SectionBox = props => {
  const { toggleAction } = props;
  return (
    <div className="section-box">
      <div className="sub-title" onClick={() => toggleAction("etcBox")}>
        특이사항
        <img
          src={_ICON_PLUS}
          id="etcBoxPlus"
          style={{ position: "absolute", width: "25px", marginLeft: "6px" }}
        />
        <img
          src={_ICON_MINUS}
          id="etcBoxMinus"
          style={{
            position: "absolute",
            width: "25px",
            marginLeft: "6px",
            display: "none",
          }}
        />
      </div>
      <div id="etcBox" style={{ display: "none" }}>
        <textarea
          className="textarea-box gray he1"
          style={{ resize: "none" }}
          maxLength="100"
          placeholder="특이사항 및 메모를 입력해주세요."
        />
      </div>
    </div>
  );
};

const SectionBoxBtn = props => {
  const { onClickToSave } = props;
  return (
    <div className="section-box">
      <div className="two-btns-area">
        <a onClick={() => _O.Open("/sm")}>취소</a>
        <a onClick={() => onClickToSave()} className="btn-aftersave">
          확인
        </a>
      </div>
    </div>
  );
};

const GaugeBox = props => {
  const { boxData, boxCount, setBoxCount, getData } = props;
  const { appStdInfo } = useContext(AppContext);

  const delGaugeBox = e => {
    setBoxCount(boxCount - 1);
    $(e.target).closest(".gauge-box").remove();
  };

  const handleKeyPress = e => {
    let idx = $("input").index(e.target);
    if (e.key === "Enter") {
      $("input")
        .eq(idx + 1)
        .focus();
    }
  };

  const scrollPage = idx => {
    if (idx == 1) {
      window.scrollTo(0, 350);
    }

    if (idx == 2) {
      window.scrollTo(0, 570);
    }

    if (idx == 3) {
      window.scrollTo(0, 800);
    }
  };

  const checkEvent = (idx, target) => {
    let maxBp = parseInt($("input[name='maxBp']")[idx - 1].value);
    let minBp = parseInt($("input[name='minBp']")[idx - 1].value);

    let targetCnt;

    let hrtRateValue;

    if ($("input[name='hrtRate']")[idx - 1].value) {
      hrtRateValue = parseInt($("input[name='hrtRate']")[idx - 1].value);
    }

    if (idx == 1) {
      targetCnt = "1차 측정";
    } else if (idx == 2) {
      targetCnt = "2차 측정";
    } else {
      targetCnt = "3차 측정";
    }

    // 수축기가 이완기보다 작을경우
    // 수축기 최대 입력값을 넘은경우

    if (maxBp === 0) {
      openAlertPopup(
        targetCnt +
          "의 수축기 값을 확인하세요. (" +
          appStdInfo.bpMin +
          "~" +
          appStdInfo.bpMax +
          ")"
      );
      return;
    }

    if (minBp === 0) {
      openAlertPopup(
        targetCnt +
          "의 이완기 값을 확인하세요. (" +
          appStdInfo.bpMin +
          "~" +
          appStdInfo.bpMax +
          ")"
      );
      return;
    }

    if (maxBp) {
      if (!(maxBp >= appStdInfo.bpMin && maxBp <= appStdInfo.bpMax)) {
        openAlertPopup(
          targetCnt +
            "의 수축기 값을 확인하세요. (" +
            appStdInfo.bpMin +
            "~" +
            appStdInfo.bpMax +
            ")"
        );
        return;
      }

      if (minBp) {
        if (!(minBp >= appStdInfo.bpMin && minBp <= appStdInfo.bpMax)) {
          openAlertPopup(
            targetCnt +
              "의 이완기 값을 확인하세요. (" +
              appStdInfo.bpMin +
              "~" +
              appStdInfo.bpMax +
              ")"
          );
          return;
        } else if (maxBp < minBp) {
          openAlertPopup("잘못된 혈압정보 입니다.");
          return;
        }
      }
    }

    if (minBp) {
      if (!(minBp >= appStdInfo.bpMin && minBp <= appStdInfo.bpMax)) {
        openAlertPopup(
          targetCnt +
            "의 이완기 값을 확인하세요. (" +
            appStdInfo.bpMin +
            "~" +
            appStdInfo.bpMax +
            ")"
        );
        return;
      }

      if (maxBp) {
        if (!(maxBp >= appStdInfo.bpMin && maxBp <= appStdInfo.bpMax)) {
          openAlertPopup(
            targetCnt +
              "의 수축기 값을 확인하세요. (" +
              appStdInfo.bpMin +
              "~" +
              appStdInfo.bpMax +
              ")"
          );
          return;
        } else if (maxBp < minBp) {
          openAlertPopup("잘못된 혈압정보 입니다.");
          return;
        }
      }
    }

    if ($("input[name='hrtRate']")[idx - 1].value) {
      if (
        !(
          hrtRateValue >= appStdInfo.hrtRateMin &&
          hrtRateValue <= appStdInfo.hrtRateMax
        )
      ) {
        openAlertPopup(
          "기록한 심박수를 확인하세요. (" +
            appStdInfo.hrtRateMin +
            "~" +
            appStdInfo.hrtRateMax +
            ")"
        );
        return;
      }
    }
  };

  return (
    <Fragment>
      {boxData.map((m, i) => (
        <div className="gauge-box" key={m.idx}>
          <div className="tit">
            {m.idx != 1 && boxCount == 3 && m.idx == boxData.length
              ? "3차 측정"
              : m.idx != 1
              ? "2차 측정"
              : "1차 측정"}

            {i > 0 && <a className="btn-delete" onClick={delGaugeBox}></a>}
          </div>
          <div className="half-input">
            <div>
              <div className="inp-with-unit fat">
                <input
                  type="number"
                  pattern="\d*"
                  className="textbox fat num highlight"
                  name="maxBp"
                  placeholder="수축기"
                  value={getData && getData.sbp}
                  onChange={e => maxLengthCheck(e, 3)}
                  onClick={() => scrollPage(m.idx)}
                  onBlur={e => checkEvent(m.idx, "MAX")}
                />
                <i>mmhg</i>
              </div>
            </div>
            <div>
              <div className="inp-with-unit fat">
                <input
                  type="number"
                  pattern="\d*"
                  className="textbox fat num"
                  name="minBp"
                  placeholder="이완기"
                  value={getData && getData.dbp}
                  onChange={e => maxLengthCheck(e, 3)}
                  onBlur={e => checkEvent(m.idx, "MIN")}
                />
                <i>mmhg</i>
              </div>
            </div>
          </div>
          <div className="full-input">
            <div className="inp-with-unit fat">
              <input
                type="number"
                pattern="\d*"
                className="textbox fat num"
                name="hrtRate"
                placeholder="심박수"
                value={getData && getData.hr}
                onChange={e => maxLengthCheck(e, 3)}
                onBlur={e => checkEvent(m.idx, "HTRT")}
              />
              <i>bpm</i>
            </div>
          </div>
        </div>
      ))}
    </Fragment>
  );
};

const BtnAddGaugeBox = props => {
  const { addGaugeBox } = props;
  return (
    <div className="gauge-add-btn">
      <a onClick={addGaugeBox} className="btn-circleplus">
        <i></i>
        <p>추가측정</p>
      </a>
    </div>
  );
};

const CheckHands = props => {
  const { settingHandsRight, settingHandsLeft } = props;
  return (
    <div className="check-hands">
      <label className="check-vtxt">
        <input
          type="radio"
          name="handscheck"
          defaultChecked={true}
          onClick={settingHandsLeft}
        />
        <i></i>
        <span>왼팔</span>
      </label>
      <label className="check-vtxt">
        <input type="radio" name="handscheck" onClick={settingHandsRight} />
        <i></i>
        <span>오른팔</span>
      </label>
    </div>
  );
};

const PeriodArea = props => {
  const { setBpcTimeCd, defaultValue } = props;
  return (
    <div className="select-input">
      {/* <div>
                <div className="select-custom-box">
                    <a href={void 0} className="btn-select">
                        아침식사전
                    </a>
                    <ul>
                        <li>
                            <a onClick={() => setBpcTimeCd("01")}>아침식사전</a>
                        </li>
                        <li>
                            <a onClick={() => setBpcTimeCd("02")}>아침</a>
                        </li>
                        <li>
                            <a onClick={() => setBpcTimeCd("03")}>점심</a>
                        </li>
                        <li>
                            <a onClick={() => setBpcTimeCd("04")}>저녁</a>
                        </li>
                        <li>
                            <a onClick={() => setBpcTimeCd("05")}>잠자기전</a>
                        </li>
                    </ul>
                </div>
            </div> */}
      <div>
        <input
          type="text"
          className="textbox datetime-picker-input pick-result"
          placeholder="날짜/시간을 선택해 주세요."
          defaultValue={defaultValue}
          readOnly
        />
      </div>
    </div>
  );
};

const InputSaveLayer = props => {
  const {
    userInfo,
    phonecfg,
    cfg,
    inptType,
    bpcTimeCd,
    bpcDate,
    bpcTime,
    bpcTrgt,
    bpcMemo,
    maxBp,
    minBp,
    hrtRate,
  } = props;

  const saveBpInput = () => {
    request1101(
      userInfo,
      phonecfg,
      cfg,
      inptType,
      bpcTimeCd,
      bpcDate,
      bpcTime,
      bpcTrgt,
      bpcMemo,
      maxBp,
      minBp,
      hrtRate
    );
  };

  return (
    <div className="blacklayer-container save-question-layer ">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div>
          <div className="blgrn-box vertical">
            <div className="blgr-title">저장</div>

            <div className="save-question-box">혈압을 저장 하겠습니까?</div>

            <div className="tbns-area">
              <a href={void 0} className="btn-round gray">
                취소
              </a>
              <a onClick={saveBpInput} className="btn-round wht">
                확인
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const request1101 = (
  userinfo,
  phonecfg,
  cfg,
  inptType,
  bpcTimeCd,
  bpcDate,
  bpcTime,
  bpcTrgt,
  bpcMemo,
  maxBp,
  minBp,
  hrtRate
) => {
  // 날짜/시간 선택 유무 체크
  if (bpcDate != "") {
    PostApi1101(
      userinfo,
      phonecfg,
      cfg,
      inptType,
      bpcTimeCd,
      bpcDate,
      bpcTime,
      bpcTrgt,
      bpcMemo,
      maxBp,
      minBp,
      hrtRate
    )
      .then(res => {
        // 결과 성공시 페이지 초기화 (계속 등록할지, 페이지 이동할지)
        if (res.resultMsg === "SUCCESS") {
          //주치의 메세지 띄우기 (조건에 맞으면)
          openLayerFn($(".doctor-message-layer"));
        } else {
          openAlertPopup("등록실패");
        }
      })
      .catch(err => {
        console.log(err);
      });
  } else {
    openAlertPopup("측정 날짜/시간을 선택해 주십시오.");
  }
};
